import { render, staticRenderFns } from "./menu-group.vue?vue&type=template&id=75363eac"
import script from "./menu-group.vue?vue&type=script&lang=js"
export * from "./menu-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports